'use client'

import { ReactElement, useEffect, useRef, useState } from 'react'
import { cn } from '../../utils'

export type SelectButtonProps = {
	selectedElem: ReactElement
	className?: string
	children: ReactElement | ReactElement[]
}

const base =
	'px-4 py-3 pl-6 rounded-full border border-gray-100 bg-white !no-repeat'
const carretUrl = `bg-[url(/images/top-black-carret.svg)]`
const downCarretUrl = `bg-[url(/images/down-black-carret.svg)]`
const carretFocusUrl = `focus:bg-[url(/images/down-black-carret.svg)]`

const wrapperBaseClass = 'relative flex flex-col mt-4 gap-2 cursor-pointer'

export const SelectButton = ({
	selectedElem,
	className,
	children,
}: SelectButtonProps) => {
	const [isOpen, setIsOpen] = useState(false)

	function toggle() {
		setIsOpen(!isOpen)
	}

	return (
		<>
			{isOpen && (
				<div
					onClick={() => setIsOpen(false)}
					className="overlay-autoclose fixed top-0 bottom-0 left-0 w-screen h-screen z-40"
				/>
			)}

			<div className={cn(wrapperBaseClass, className)}>
				<div
					className={cn(
						base,
						isOpen ? carretUrl : downCarretUrl,
						carretFocusUrl,
					)}
					style={{
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'right 1.5rem top 50%',
						backgroundSize: '0.65rem auto',
					}}
					onClick={toggle}
				>
					{selectedElem}
				</div>
				{isOpen && (
					<div className="absolute top-full left-0 w-full p-2 py-4 rounded-[34px] border border-gray-100 shadow bg-white z-40 mt-2">
						<ul className="flex flex-col gap-2 max-h-72 px-2 overflow-y-auto scrollbar scrollbar-thumb-primary scrollbar-track-gray-100 scrollbar-w-1 scrollbar-thumb-rounded-full scrollbar-track-rounded-full">
							{children}
						</ul>
					</div>
				)}
			</div>
		</>
	)
}
